import { Lead } from '~/models/Lead'
import { Site2 } from '~/models/Site'
import { Spot2 } from '~/models/Spot'
import { SpotEntityMapper } from '../spot/entityMapper'
import { ApiLead, ApiLeadItinerary } from './apiTypes'

export class BusinessApiMapper {
	static toApiLead(
		form: Lead,
		site: Site2,
		spots?: Spot2[],
		itinerary?: Record<string, Spot2[]>,
		title?: string,
		assistantName?: string
	): ApiLead {
		const apiLead: ApiLead = {
			email: form.email,
			subdomain: site.subdomain!,
			destination_id: site.destination.id,
			communications: form.acceptCommunications,
			spots_ids: spots ? spots.map((spot) => spot.id!) : [],
			enterprise_logo: site.client ? site.client.image! : '',
			header_image: site.destination.cover || '',
			pdf_type: 'extended',
		}
		if (itinerary) apiLead.itinerary_days = this.toApiLeadItinerary(itinerary)
		if (title) apiLead.title = title
		if (assistantName) apiLead.assistant_name = assistantName

		return apiLead
	}

	static toLeadItinerary(apiItinerary: ApiLeadItinerary): Record<string, Spot2[]> {
		const mapped: Record<string, Spot2[]> = {}
		Object.entries(apiItinerary).forEach(([day, apiSpots]) => {
			mapped[day] = SpotEntityMapper.toSpots(apiSpots)
		})
		return mapped
	}

	static toApiLeadItinerary(itinerary: Record<string, Spot2[]>): Record<string, string[]> {
		const mapped: Record<string, string[]> = {}
		Object.entries(itinerary).forEach(([day, spots]) => {
			mapped[day] = spots.map((spot) => spot.id!)
		})
		return mapped
	}
}
